export default class CognitoConfigStore {
  baseUrl: string;
  tokenUrl: string;
  clientId: string;
  redirectUri: string;
  scope: string;
  forgotPwdUrl: string;

  constructor(config: any) {
    this.baseUrl = config.BASE_URL;
    this.tokenUrl = config.TOKEN_URL;
    this.clientId = config.CLIENT_ID;
    this.redirectUri = config.REDIRECT_URI;
    this.scope = config.SCOPE;
    this.forgotPwdUrl = config.FORGOT_PWD_URL;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  getTokenUrl() {
    return this.tokenUrl;
  }

  getClientId() {
    return this.clientId;
  }

  getRedirectUri() {
    return this.redirectUri;
  }

  getScope() {
    return this.scope;
  }

  getForgotPwdUrl() {
    return this.forgotPwdUrl;
  }
}
